<template>
    <v-container fluid>
        <v-form ref="prospetto" v-model="valid" lazy-validation id="formSalva">
            <v-row>
                <v-col cols="12" class="text-left pb-0">
                    <v-row>
                        <v-container fluid class="pb-0">
                            <span class="pink title text-uppercase py-1 px-2">i tuoi dati</span>
                            <v-row>
                                <v-col cols="12">
                                    <p class="caption text-lowercase">*campi obbligatori</p>
                                </v-col>
                                <v-col cols="12">
                                    <v-row>
                                        <v-col cols="12" md="6" id="name">
                                            <v-text-field v-model="name" label="Nome*" :rules="inputRules"
                                                          id="firstNameInput"
                                                          required></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" id="lastName">
                                            <v-text-field v-model="lastName" label="Cognome*"
                                                          id="lastNameInput"
                                                          :rules="inputRules"
                                                          required></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" id="email">
                                            <v-text-field v-model="email" label="E-mail*"
                                                          id="emailInput"
                                                          :rules="emailRules" required>
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" id="date">
                                            <v-text-field
                                                    maxlength="10"
                                                    @keyup="date=formatDate(date)"
                                                    color="AXABlue"
                                                    label="Data di nascita*"
                                                    placeholder="GG/MM/AAAA"
                                                    :rules="dateRules"
                                                    v-model="date"
                                                    type="tel"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" class="pt-5">
                                            <a href="/docs/mps/privacy_2026.pdf" target="_blank" class="privacy__link pt-5">Informativa privacy</a>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>

<script>
    import * as moment from 'moment';
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "FormSalva",
        components: {},
        computed: {
            ...mapGetters({
                'getInsuredData': 'params/getInsuredData',
            }),
        },
        watch: {},
        data: () => ({
            valid: false,
            inputRules: [
                v => !!v || 'Campo obbligatorio',
            ],
            name: '',
            lastName: '',
            telephone: '',
            date: '',
            dateRules: [
                val => moment(val, "DD/MM/YYYY") >= moment().subtract(60, 'years') && moment(val, "DD/MM/YYYY") <= moment().subtract(18, 'years') || `L'età deve essere compresa tra 18 e 60 anni`,
                val => /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/(19|20)\d\d$/i.test(val) || 'La data deve avere formato gg/mm/aaaa',
            ],
            email: '',
            emailRules: [
                v => !!v || 'Campo obbligatorio',
                v => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(v) || 'E-mail non valida',
            ],
            idSession: sessionStorage.getItem('sessionId'),
        }),
        mounted() {
            this.name = this.getInsuredData.name;
            this.date = this.getInsuredData.date;
        },
        methods: {
            ...mapActions({
                'actionIsFormValidate': 'stickyBar/actionIsFormValidate',
                'actionIsDisable': 'stickyBar/actionIsDisable',
                'actionSaveData': 'params/actionSaveData',
            }),
            formatDate: function (value) {
                value = value.replace(/\D/g, "")
                    .split(/(..)/)
                    .filter(s => s.length > 0)
                    .reduce((t, v, i, a) => t + v + (i > 1 || i == a.length - 1 ? '' : '/'), '');
                return value;
            }
        },
        updated() {
            if (this.name != '' && this.lastName != '' && this.email != '' && this.date != '' && this.valid) {
                let data = {
                    name: this.name,
                    lastName: this.lastName,
                    email: this.email,
                    date: this.date,
                    priv: 'si',
                };

                this.actionSaveData(data);
                this.actionIsDisable(false);
                this.actionIsFormValidate(true);
            } else {
                this.actionIsDisable(true);
            }
        },
    };
</script>
